
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
@Component({
  components: {
    DsEditor,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifCompose: any;
  @Prop()
  private detail: any;
  @Watch("detail", { immediate: true })
  private detailChange() {
    // 处理数据
    this.data = JSON.parse(JSON.stringify(this.detail));
  }
  private data: any = {};
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private getText(data: any) {
    if (data && data.length > 0) {
      return data.map((item: any) => item.name).join('、');
    }
    return '/';
  }
  private getYao(data: any) {
    if (data && data.length > 0) {
      return data.map((item: any) => item.herb.name + ' ' + item.quantity + item.unit).join('、');
    }
    return '/';
  }
  private editorChange(e: any) {
    this.data.report.suggest = e;
    const d = JSON.parse(JSON.stringify(this.data));
    d.report.suggest = e;
    this.change();
  }
  private change() {
    this.$emit("changeData", this.data);
  }
  private open(url: any) {
    window.open(url);
  }
  private mounted() { }
}
